import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { saveQuestionApi } from 'api/reviews';
import { sendRequest } from 'api/sendRequest';

import { endpoints } from 'constants/endpoints';
import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import { getOrgModulesSettings } from 'services/admin';
import { getCompetencySettings, setCompetencySettings } from 'services/competencies';

import { Label } from './types/labels';
import { ModuleAccess } from './types/modules';

export const useGetOrgModulesSettingsQuery = () =>
  useQuery<ModuleAccess>({
    queryKey: [REACT_QUERY_KEYS.orgModuleSettings],
    queryFn: getOrgModulesSettings,
  });

export const useUpdateCompetencySettingsMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<unknown, unknown, { viewType: string }>(({ viewType }) => setCompetencySettings({ viewType }), {
    onSuccess: () => {
      queryClient.invalidateQueries([REACT_QUERY_KEYS.competencyDrawerNew.competencySettings]);
    },
  });
};

const getLabelSettings = (): Promise<{ entity: Label }> => {
  const url = endpoints.competency.labelConfig;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: undefined,
  });
};

export const useGetCompetencyLabelsQuery = () =>
  useQuery<Label>({
    queryKey: [REACT_QUERY_KEYS.competencyDrawerNew.labelConfig],
    queryFn: () => getLabelSettings().then((res) => res.entity),
  });

export const useUpdateCompetencyLabelsMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<unknown, unknown, { label: Label }>(({ label }) => saveQuestionApi({ question: label }), {
    onSuccess: () => {
      queryClient.invalidateQueries([REACT_QUERY_KEYS.competencyDrawerNew.labelConfig]);
    },
  });
};

export const useGetCompetencySettingsQuery = () =>
  useQuery({
    queryKey: [REACT_QUERY_KEYS.competencyDrawerNew.competencySettings],
    queryFn: () => getCompetencySettings(),
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
